import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { EuropaceProcessEventsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus =
    EuropaceProcessEventsTableDefinitionZod.shape.requestStatus.nullable();

export type SchemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus = z.infer<
    typeof schemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus
>;

export type LoanRequestResolver_GetEuropaceProcessEventsRequestStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus
>;
